import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TrustPayService {

  constructor() { }

  public paymentUrl(registrationId: number, secureHash: string): Promise<string> {
    return new Promise((resolve, reject) => resolve('http://localhost:8080/some/trustpay/url'));
  }
}
